import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './Header.scss';

import Cookies from 'universal-cookie';
import NavigationToggle from '../UI/NavigationToggle/NavigationToggle';
import traverseLogo from '../../assets/images/traverse-logo.png';

import TextSpinner from '../UI/TextSpinner/TextSpinner';

import { 
    showSideNavigation, 
    resetSearch, 
    resetFilters, 
    switchHeaderView, 
    resetPollingCounter, 
    hideReturnFlights,
    resetFarePrice,
    resetAddons,
    closeSidebar,
    closeDesktopFilters,
    resetStackFlight
  } from '../../store/actions/index';
import * as authActions from '../../store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Header extends Component {

    state = {
        isDropdownOneOpen: false,
        isDropdownTwoOpen: false,
        isSubMenuVisible: 9999
    }

    backButtonHandler = () => {
        this.props.onCloseSidebar();
        this.props.onCloseDesktopFilters();
        this.props.onResetFilters();
        this.props.history.goBack();
        this.props.onSwitchHeaderView('calendar');
    }

    componentWillMount() {
        if (this.props.userProfile === null && localStorage.getItem('ssoToken') !== null) {
            const cookies = new Cookies();
            cookies.set('ssoToken', localStorage.getItem('ssoToken'), { path: '/' });
            // this.props.onGetAgentHeader(localStorage.getItem('ssoToken'));
            // this.props.onGetAgentFooter(localStorage.getItem('ssoToken'));
            this.props.onGetUserProfile(localStorage.getItem('ssoToken'));
            this.props.onGetProductAccess(localStorage.getItem('ssoToken'));
            this.props.onGetBanners(localStorage.getItem('ssoToken'));
            this.props.onGetFlightRecentBooking(localStorage.getItem('ssoToken'));
        }
        document.addEventListener('mousedown', this.handleClick, false);

        let isLoggedIn = false;
        const loginToken = localStorage.getItem('ssoToken');
        if (loginToken !== null) { isLoggedIn = true; }

        if (isLoggedIn) {
            this.props.onUpdateLoginStatus(true);
        }
        let scriptHeader = document.createElement("script");
        scriptHeader.src = "//assets.adobedtm.com/launch-EN3cb9cf86bcae414bad03ae714f1d8c3f-development.min.js";
        scriptHeader.async = true;
        const scriptText = document.createTextNode("_satellite.pageBottom();");
        scriptHeader.appendChild(scriptText);
        document.body.appendChild(scriptHeader);

        // let scriptFooter = document.createElement("script");
        // const scriptText = document.createTextNode("_satellite.pageBottom();");

        // scriptFooter.appendChild(scriptText);
        // document.body.appendChild(scriptFooter);
    }

    componentDidUpdate(prevProps) {
      const isLoggingOut = prevProps.isLoggedIn && !this.props.isLoggedIn;
      const isLoggingIn = !prevProps.isLoggedIn && this.props.isLoggedIn;
      if (!isLoggingIn) {
        if (this.props.location.pathname.trim('') === '/') { this.props.history.push('/flight'); }
        this.props.onGetUserProfile(localStorage.getItem('ssoToken'));
        this.props.onGetProductAccess(localStorage.getItem('ssoToken'));
        this.props.onGetBanners(localStorage.getItem('ssoToken'));
        this.props.onGetFlightRecentBooking(localStorage.getItem('ssoToken'));
      }
      if (isLoggingOut) this.props.history.push('/');
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    toggleDropdownHandler = (val) => {
        if (val === 1) {
            if (this.props.userHeaderMenu === null) {
                this.props.onGetHeaderMenu(localStorage.getItem('ssoToken'));
            }
            this.setState((prevState) => {
                return { 
                    isDropdownOneOpen: !prevState.isDropdownOneOpen,
                    isDropdownTwoOpen: false,
                    isSubMenuVisible: 9999
                }
            })
        } else {
            if (this.props.userBalance === null) {
                this.props.onGetBalance(localStorage.getItem('ssoToken'));
            }
            if (this.props.userHeaderMenu === null) {
                this.props.onGetHeaderMenu(localStorage.getItem('ssoToken'));
            }
            this.setState((prevState) => {
                return { 
                    isDropdownTwoOpen: !prevState.isDropdownTwoOpen,
                    isDropdownOneOpen: false,
                    isSubMenuVisible: 9999
                }
            })
        }
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) {
            return;
        }

        this.setState({
            isDropdownOneOpen: false,
            isDropdownTwoOpen: false,
            isSubMenuVisible: 9999
        })
    }

    toggleSubMenuHandler = (index) => {
        this.setState({
            isSubMenuVisible: index
        })
    }

    render() {
        let scriptJSX = null;
        if(this.props.agentHeaderData) {
            scriptJSX = <div dangerouslySetInnerHTML={{ __html: this.props.agentHeaderData }} />;
        }
        // if(this.props.agentFooterData) {
        //     scriptJSX = <div dangerouslySetInnerHTML={{ __html: this.props.agentFooterData }} />;
        // }
        let userMyAccounts = null;
        let userMainMenu = null;
        if (this.props.userHeaderMenu) {
            userMyAccounts = this.props.userHeaderMenu["My Accounts"];
            userMainMenu = this.props.userHeaderMenu["Main Menu"];
        }
        const loginToken = localStorage.getItem('ssoToken');
        const colorDark = "var(--color-grey-dark-1)";

        return (
            <div className={`${classes.Header} u-flex u-width100Percent u-backgroundColorWhite pr-7 phone-pr-0 u-boxShadowNormal u-transitionAll300Ease`}>
                <div className={`u-flex`} style={{
                    transition: '.3s ease',
                    transform: !this.props.isLoggedIn ? 'translateX(0)' : 'translateX(-6rem)'
                }}>
                    {/* {this.props.location.pathname.trim('').includes('/reviews') || this.props.location.pathname.trim('').includes('/reviewHotel') || this.props.location.pathname.trim('').includes('/details') ? (
                        <button className={`${classes.ButtonToggle} u-flex align-items-center justify-content-center u-cursorPointer u-backgroundColorWhite u-border0 mr-3`} onClick={this.backButtonHandler}><img src={arrowBack} alt="Go back" /></button>
                    ) : (
                        <button className={`${classes.ButtonToggle} u-flex align-items-center justify-content-center u-cursorPointer u-backgroundColorWhite u-border0 mr-3`}
                            onMouseEnter={() => this.props.isLoggedIn ? this.props.onShowSideNavigation() : null}
                        ><img src={burgerMenuIcon} alt='Icon'/></button>
                    )} */}
                    <button className={`${classes.ButtonToggle} u-flex align-items-center justify-content-center u-cursorPointer u-backgroundColorTransparent u-border0 mr-3`}
                            onMouseEnter={() => this.props.isLoggedIn ? this.props.onShowSideNavigation() : null}
                        >
                            <NavigationToggle isHeaderNav />
                        </button>
                    <button 
                        className={`u-cursorPointer u-border0 u-outline0 u-height100Percent u-backgroundColorTransparent u-fontSize13 u-fontWeightRegular u-textColorDark u-flex align-items-center`}
                        onClick={() => {
                            !this.props.isLoggedIn ? this.props.history.push('/flight') : this.props.history.push('/') 
                            this.props.onResetPollingCounter();
                            this.props.onResetStackFlight();
                            this.props.onResetSearch();
                            this.props.onResetFarePrice();
                            this.props.onResetAddons();
                            this.props.onHideReturnFlights();
                            this.props.onStopAuthentication();
                            this.props.onSetAuthView('home');
                            this.props.onCloseSidebar();
                        }}>
                        <img src={traverseLogo} alt="Logo" className={`u-size22x22`} />
                        <span className={`ml-2 u-textColorDark u-fontWeightMedium u-fontSize16`}>Traverse</span>
                    </button>
                </div>
                <div className={`u-flex align-items-center justify-content-between ml-auto u-lineHeight15Rem`} ref={node => this.node = node}>
                    {
                        this.props.isLoggedIn ? 
                        <React.Fragment>
                            <button className={`u-backgroundColorTransparent u-border0 u-outline0 u-cursorPointer u-flex align-items-center`} onClick={() => this.toggleDropdownHandler(1)}>
                                {
                                    !this.props.userProfileLoading ?
                                    <React.Fragment>
                                        <div>
                                            <span className={`u-textColorNormal u-fontSize13`}>Main Menu</span>
                                        </div>
                                    </React.Fragment> : <TextSpinner type='Light' />
                                }
                            </button>
                            {
                                this.state.isDropdownOneOpen ? 
                                <div className={`u-width140 u-absolute u-boxShadowThin u-backgroundColorWhite pt-2 pb-2 pl-2 pr-2 u-borderBottomLeft4 u-borderBottomRight4 u-top45 u-right200 u-phone-right40`}>
                                    <ul>
                                        {
                                            userMainMenu && userMainMenu.map((menuItem, index) => {
                                                console.log(menuItem);
                                                if (menuItem.label === 'General Insurance') return null;
                                                if (menuItem.children) {
                                                    return <li key={index} onClick={() => this.toggleSubMenuHandler(index)}>
                                                        <div style={{ display: index === this.state.isSubMenuVisible ? 'block' : 'none' }} className={`u-width150 u-absolute u-boxShadowThin u-backgroundColorWhite pt-2 pb-2 pl-3 pr-3 u-right100Percent`}>
                                                            <ul>
                                                                {
                                                                    menuItem.children.map((subMenuItem, subIndex) => {
                                                                        return <li key={subIndex} className={`mb-2`}><a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer u-block u-hover-textColorDark`} href={subMenuItem.url} target="_blank">{subMenuItem.label}</a></li>
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                        <a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer mb-2 u-block u-hover-textColorDark`} href={menuItem.url} target="_blank"><span className={`u-width10 u-inlineBlock`}><FontAwesomeIcon icon="caret-left" color="#666" size="1x" /></span>{menuItem.label}</a>
                                                    </li>
                                                }
                                                return <li key={index}><a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer mb-2 u-block u-hover-textColorDark`} href={menuItem.url} target="_blank"><span className={`u-width10 u-inlineBlock`}></span>{menuItem.label}</a></li>
                                            })
                                        }
                                    </ul>
                                </div> : null
                            }
                            <span className={`ml-4 mr-4 phone-ml-2 phone-mr-2 u-textColorLightest`}>|</span>
                            <button className={`u-backgroundColorTransparent u-border0 u-outline0 u-cursorPointer u-flex align-items-center u-minWidth120 u-phone-minWidthAuto`} onClick={() => this.toggleDropdownHandler(2)}>
                                {
                                    !this.props.userProfileLoading ? 
                                    <React.Fragment>
                                        <div className={`mr-2`}>
                                            <div className={`u-size25x25 u-borderRadius50 u-verticalAlignMiddle u-inlineBlock u-backgroundPrimary u-textColorWhite u-flex align-items-center justify-content-center`}><span className="u-lineHeight1 u-fontSize13 u-fontWeightMedium">{this.props.userProfile ? this.props.userProfile.userDetail.firstName.charAt(0).toUpperCase() : 'First Name'}</span></div>
                                        </div>
                                        <div className={`mr-1 u-lineHeight1`}>
                                            <span className={`u-textColorDark u-fontSize13 u-phoneHide`}>{this.props.userProfile.userDetail.firstName}&nbsp;<span className={`u-phoneHide`}>{this.props.userProfile.userDetail.lastName}</span></span>
                                        </div>
                                        <div className={`u-transition--transform200Spring u-phoneHide`} style={{  transform: this.state.isDropdownTwoOpen ? 'rotate(270deg)' : 'rotate(90deg)' }}>
                                            <FontAwesomeIcon icon="caret-right" color={`${colorDark}`} size="1x" />
                                        </div>
                                    </React.Fragment> : <TextSpinner type='Light'/>
                                }
                            </button>
                            {
                                this.state.isDropdownTwoOpen ? 
                                <div className={`u-width150 u-absolute u-boxShadowDropdown u-backgroundColorWhite pt-2 pb-2 pl-2 pr-2 u-borderBottomLeft4 u-borderBottomRight4 u-top45 u-right34 u-phone-right15`}>
                                    <ul>
                                        {  <li className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer mb-2 u-block u-hover-textColorDark`}><span className={`u-width10 u-inlineBlock`}></span>{ this.props.userBalance && this.props.userBalance.showBal === 1 ?  <span>Balance &#8377; {Math.round(parseFloat(this.props.userBalance.cashPool))}</span> : <TextSpinner type='Light' /> }</li>  }
                                        {
                                            userMyAccounts && userMyAccounts.map((menuItem, index) => {
                                                if (menuItem.children) {
                                                    return <li key={index} onClick={() => this.toggleSubMenuHandler(index)}>
                                                        <div style={{ display: index === this.state.isSubMenuVisible ? 'block' : 'none' }} className={`u-width150 u-absolute u-boxShadowThin u-backgroundColorWhite pt-2 pb-2 pl-3 pr-3 u-right100Percent`}>
                                                            <ul>
                                                                {
                                                                    menuItem.children.map((subMenuItem, subIndex) => {
                                                                        return <li key={subIndex} className={`mb-2`}><a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer u-block u-hover-textColorDark`} href={subMenuItem.url} target="_blank">{subMenuItem.label}</a></li>
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                        <a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer mb-2 u-block u-hover-textColorDark`} href={menuItem.url} target="_blank"><span className={`u-width10 u-inlineBlock`}><FontAwesomeIcon icon="caret-left" color="#666" size="1x" /></span>{menuItem.label}</a>
                                                    </li>
                                                }
                                                return <li key={index} className={`mb-2`}><a className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer u-block u-hover-textColorDark`} href={menuItem.url} target="_blank"><span className={`u-width10 u-inlineBlock`}></span>{menuItem.label}</a></li>
                                            })
                                        }
                                        {/* <NavLink to='/user/dashboard' className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer mb-2 u-block`} onClick={() => {
                                            this.toggleDropdownHandler();
                                        }}><span className={`u-width10 u-inlineBlock`}></span>Edit Profile</NavLink> */}
                                        <li className={`u-textColorNormal u-fontSize13 u-fontWeightRegular u-cursorPointer u-hover-textColorDark`} onClick={() => {
                                                this.toggleDropdownHandler();
                                                this.props.onAuthLogout(loginToken);
                                            }}><span className={`u-width10 u-inlineBlock`}></span>Logout</li>
                                    </ul>
                                </div> : null
                            }
                        </React.Fragment> : null
                    }
                </div>
                {scriptJSX}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userProfile: state.auth.userProfile,
        userProfileLoading: state.auth.userProfileLoading,
        isLoggedIn: state.auth.isLoggedIn,
        userBalance: state.auth.userBalance,
        userHeaderMenu: state.auth.userHeaderMenu,
        agentHeaderData: state.auth.agentHeaderData,
        agentFooterData: state.auth.agentFooterData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onShowSideNavigation: () => dispatch(showSideNavigation()),
        onResetSearch: () => dispatch(resetSearch()),
        onResetFarePrice: () => dispatch(resetFarePrice()),
        onResetAddons: () => dispatch(resetAddons()),
        onResetPollingCounter: () => dispatch(resetPollingCounter()),
        onResetStackFlight: () => dispatch(resetStackFlight()),
        onHideReturnFlights: () => dispatch(hideReturnFlights()),
        onSetAuthView: (view) => dispatch(authActions.setAuthView(view)),
        onStopAuthentication: () => dispatch(authActions.stopAuthentication()),
        onGetUserProfile: (ssoToken) => dispatch(authActions.getUserProfile(ssoToken)),
        onGetHeaderMenu: (ssoToken) => dispatch(authActions.getHeaderMenu(ssoToken)),
        onGetProductAccess: (ssoToken) => dispatch(authActions.getProductAccess(ssoToken)), 
        onGetBalance: (ssoToken) => dispatch(authActions.getBalance(ssoToken)),
        onGetBanners: (ssoToken) => dispatch(authActions.getBanners(ssoToken)),
        onUpdateLoginStatus: (status) => dispatch(authActions.updateLoginStatus(status)),
        onAuthLogout: (ssoToken) => dispatch(authActions.authLogout(ssoToken)),
        onGetFlightRecentBooking: (ssoToken) => dispatch(authActions.getFlightRecentBooking(ssoToken)),
        onCloseSidebar: () => dispatch(closeSidebar()),
        onCloseDesktopFilters: () =>  dispatch(closeDesktopFilters()),
        onResetFilters: () => dispatch(resetFilters()),
        onSwitchHeaderView: (view) => dispatch(switchHeaderView(view)),
        onGetAgentHeader: (ssoToken) => dispatch(authActions.getAgentHeader(ssoToken)),
        onGetAgentFooter: (ssoToken) => dispatch(authActions.getAgentFooter(ssoToken))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js